export default __webpack_public_path__ + "bded608a0f7b1da382aeb92c30a1c9b4.ttf";